import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteClaseDeConceptosDeInfraccion,
  getClaseDeConceptosDeInfracciones,
  patchClaseDeConceptosDeInfraccion,
  postClaseDeConceptosDeInfraccion,
} from 'api/catalogos/claseDeConceptoDeInfracciones';

// eslint-disable-next-line react/prop-types
const ClaseDeConceptoDeInfracciones = ({ permission }) => (
  <PlainCRUD
    title="Concepto de Infracción"
    permission={permission}
    get={getClaseDeConceptosDeInfracciones}
    post={postClaseDeConceptosDeInfraccion}
    patch={patchClaseDeConceptosDeInfraccion}
    delete={deleteClaseDeConceptosDeInfraccion}
    withoutState
    fields={[
      defaultFields.descripcion,
    ]}
  />
);

export default ClaseDeConceptoDeInfracciones;
